import { Userpilot } from 'userpilot';

let initialized = false;

export function initUserpilot(token: string) {
  if (initialized) return;
  Userpilot.initialize(token);
  initialized = true;
}

export function identifyUser(user: { id: string; name?: string; email?: string }) {
  if (!initialized) return;
  Userpilot.identify(user.id, {
    name: user.name,
    email: user.email,
  });
}

export function disableUserpilot() {
  if (!initialized) return;
  // Clear Userpilot instance manually
  (window as any).userpilot = undefined;
  initialized = false;
}
